import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import UnableToRescheduleModal from './UnableToRescheduleModal';
import { nullFunc } from '../../utils/helpers';

const RescheduleLink = ({ rescheduleLink, onClick, off, toggled }) => (
  <div className="u-mb--">
    <Link
      className="c-btn c-btn--secondary u-1/1"
      to={rescheduleLink}
      onClick={onClick}
    >
      Reschedule appointment
    </Link>
    <UnableToRescheduleModal
      isOpen={toggled}
      closeModal={off}
    />
  </div>
);
RescheduleLink.propTypes = {
  rescheduleLink: PropTypes.string,
  onClick: PropTypes.func,
  off: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
};
RescheduleLink.defaultProps = {
  rescheduleLink: '',
  onClick: nullFunc,
};

export default RescheduleLink;



// WEBPACK FOOTER //
// ./src/app/reservation/components/RescheduleLink.jsx